export default "__VITE_ASSET__B9$2$bld__"